<template>
  <div class="page" :style="themeStyle">
    <div v-if="!loaded" class="loading">Loading…</div>
    <div v-if="loaded" class="root">

      <!-- Gold hairline top -->
      <div class="gilt-topbar"></div>

      <!-- Nav -->
      <nav class="nav">
        <img :src="darkLogoUrl" class="nav-logo" />
        <div class="nav-duo">
          <span class="nd-lo">{{ loName || "Loan Officer" }}</span>
          <span class="nd-line"></span>
          <span class="nd-re">{{ realtorName || "Realtor" }}</span>
        </div>
     
      </nav>

      <!-- Hero — rich dark panel -->
      <section class="hero">
        <!-- Fine grid texture overlay -->
        <div class="hero-grid" aria-hidden="true"></div>
        <div class="hero-inner">
          <div class="hero-left">
   
            <h1 class="hero-h1" v-html="heroH1Html"></h1>
            <p class="hero-body">{{ heroBody }}</p>
                          <div class="hero-btns">
              <a class="btn-gold" :href="applyRightLink">{{ heroPrimaryText }}</a>
              <a v-if="applyLeftLink" class="btn-ghost" :href="applyLeftLink">{{ heroSecondaryText }}</a>
            </div>
      <section class="realtor-section">
        <div class="re-card">
          <div class="re-card-img">
            <img v-if="realtor && realtor.headshot_url" :src="realtor.headshot_url" class="re-photo" />
          </div>
          <div class="re-card-body">
            <span class="re-eyebrow">Partner</span>
            <div class="re-name">{{ realtorName }}</div>
            <div class="re-brokerage">{{ realtor && realtor.brokerage_name ? realtor.brokerage_name : "" }}</div>
            <div class="re-contacts">
              <a v-if="realtor && realtor.phone_number" :href="'tel:' + realtor.phone_number" class="re-link">{{ realtor.phone_number }}</a>
              <a v-if="realtor && realtor.email" :href="'mailto:' + realtor.email" class="re-link">{{ realtor.email }}</a>
              <a v-if="realtor && realtor.website_url" :href="realtor.website_url" class="re-link" target="_blank" rel="noreferrer">Visit Website</a>
            </div>
          </div>
        
        </div>
      </section>
        
          </div>
          <div class="hero-right">
            <!-- Large portrait treatment for LO -->
            <div class="portrait-frame">
              <img v-if="loinfo && loinfo.lo_image" :src="loinfo.lo_image" class="portrait-img" />
              <div class="portrait-overlay"></div>
              <div class="portrait-label">
                <span class="pl-name">{{ loName }}</span>
                <span class="pl-role">{{ loTitle }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- Gold corner ornament -->
        <div class="corner-ornament tl" aria-hidden="true">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none"><path d="M2 2h20M2 2v20" stroke="currentColor" stroke-width="1.2"/><circle cx="2" cy="2" r="2" fill="currentColor"/></svg>
        </div>
        <div class="corner-ornament br" aria-hidden="true">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none"><path d="M46 46h-20M46 46v-20" stroke="currentColor" stroke-width="1.2"/><circle cx="46" cy="46" r="2" fill="currentColor"/></svg>
        </div>

      </section>

      <!-- Contact info strip -->
      <div class="contact-bar">
        <div class="cb-rule"></div>
        <div class="cb-items">
          <a v-if="loinfo && loinfo.phone_number" class="cb-item" :href="'tel:' + loinfo.phone_number">
            <span class="cb-label">Phone</span>
            <span class="cb-val">{{ loinfo.phone_number }}</span>
          </a>
          <div class="cb-sep"></div>
          <a v-if="loinfo && loinfo.email" class="cb-item" :href="'mailto:' + loinfo.email">
            <span class="cb-label">Email</span>
            <span class="cb-val">{{ loinfo.email }}</span>
          </a>
          <div v-if="loinfo && loinfo.nmls" class="cb-sep"></div>
          <div v-if="loinfo && loinfo.nmls" class="cb-item">
            <span class="cb-label">NMLS</span>
            <span class="cb-val">{{ (loinfo.nmls || "").trim() }}</span>
          </div>
        </div>
        <div class="cb-rule"></div>
      </div>

  

      <!-- Footer -->
      <footer class="footer">
        <div class="ft-gold-rule"></div>
        <div class="ft-inner">
          <span class="ft-copy">{{ loName }} · {{ realtorName }}</span>
          <span class="ft-links">
  
          </span>
        </div>
      </footer>

    </div>
  </div>
</template>

<script>
import coBrandMixin from "../../mixins/coBrandMixin.js";
const BRAND_COLORS = {
  zonalending:        { primary: "#eb610a", accent: "#646363" },
  radiantmortgage:    { primary: "#1C1F39", accent: "#DB9457" },
  conradmortgage:     { primary: "#4a4b4b", accent: "#d4af37" },
  theimgteam:         { primary: "#ff6633", accent: "#4a4c54" },
  responsivemortgage: { primary: "#07212c", accent: "#FF7F47" },
  kpmortgage:         { primary: "#0D2821", accent: "#34BFC6" },
  ignitemortgage:     { primary: "#000000", accent: "#00b1eb" },
  goldstarfinancial:  { primary: "#0b1726", accent: "#c69c39" },
};
const DBA_BASE = "https://api.goldstarfinancial.com/DBA";
function dbaLogo(brandKey, variant = "primary") { return `${DBA_BASE}/${brandKey}/${variant}.png`; }
function getBrandKey(email) {
  if (!email) return null;
  const d = email.slice(email.indexOf("@") + 1).toLowerCase();
  return d.split(".")[0] || null;
}
export default {
  name: "CoBrandGilt",
  mixins: [coBrandMixin],
  computed: {
    brandKey() { const k = getBrandKey(this.loinfo?.email); return (k && BRAND_COLORS[k]) ? k : "goldstarfinancial"; },
    palette() { return BRAND_COLORS[this.brandKey] || BRAND_COLORS.goldstarfinancial; },
    themeStyle() { return { "--p": this.palette.primary, "--a": this.palette.accent }; },
    darkLogoUrl() { return dbaLogo(this.brandKey, "primary"); },
    
    heroH1Html() {
      const h = (this.realtor?.header1 || this.loinfo?.header1 || "").trim();
      if (!h) return "Ready to get<br/><em>started?</em>";
      const parts = h.split(",");
      if (parts.length > 1) {
        const a = parts[0].trim();
        const b = parts.slice(1).join(",").trim();
        return `${a}<br/><em>${b}</em>`;
      }
      return h;
    },
    
    heroHeading() { return this.loinfo?.text_section_heading || "About"; },
    heroPrimaryText() { return this.loinfo?.right_button_text || "Apply Now"; },
    heroSecondaryText() { return this.loinfo?.left_button_text || "Schedule Appointment"; },
    heroBody() {
      const m = (this.realtor?.main || this.loinfo?.main || "").trim();
      if (m) return m;
      const p = [this.loinfo?.text_section_body_p1, this.loinfo?.text_section_body_p2].filter(Boolean).join(" ").trim();
      return p || this.loinfo?.footer_slogan || "Start your application in minutes and we'll guide you from application through closing.";
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Didact+Gothic&family=Tenor+Sans&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Libre+Baskerville:ital,wght@0,400;0,700;1,400&family=Raleway:wght@300;400;500;600&display=swap');

.page {
  min-height: 100vh;
  background: #0e0e12;
  color: #f0ede8;
  font-family: 'Raleway', sans-serif;
  --p: #0b1726;
  --a: #c69c39;
  --gold: #c8a96e;
  --gold-dim: rgba(200,169,110,0.4);
  --gold-faint: rgba(200,169,110,0.1);
  --bg: #0e0e12;
  --surface: #16161e;
  --surface2: #1e1e28;
  --hairline: rgba(200,169,110,0.18);
  --text: #f0ede8;
  --muted: rgba(240,237,232,0.55);
}
.root { display: flex; flex-direction: column; min-height: 100vh; }

.gilt-topbar { height: 2px; background: linear-gradient(90deg, transparent, var(--gold), var(--gold-dim), transparent); }

/* NAV */
.nav { display: flex; align-items: center; justify-content: space-between; padding: 20px 52px; border-bottom: 1px solid var(--hairline); }

.nav-logo { width: 160px;  object-fit: contain;  filter: brightness(0) invert(1); opacity: 0.9; } .nav-logo { width: 160px; height: auto; object-fit: contain; }
.nav-duo { display: flex; align-items: center; gap: 14px; font-size: 12px; letter-spacing: 0.08em; }
.nd-lo { color: var(--text); font-weight: 500; }
.nd-line { width: 28px; height: 1px; background: var(--gold-dim); }
.nd-re { color: var(--muted); }
.nav-cta { font-size: 11px; font-weight: 500; letter-spacing: 0.14em; text-transform: uppercase; text-decoration: none; color: var(--gold); border: 1px solid var(--gold-dim); padding: 9px 22px; border-radius: 3px; transition: background 0.2s, color 0.2s; }
.nav-cta:hover { background: var(--gold-faint); }

/* HERO */
.hero { position: relative; display: grid; grid-template-columns: 1fr 1fr; min-height: 520px; overflow: hidden; }
.hero-grid {
  position: absolute; inset: 0;
  background-image: linear-gradient(var(--hairline) 1px, transparent 1px), linear-gradient(90deg, var(--hairline) 1px, transparent 1px);
  background-size: 60px 60px;
  opacity: 0.4; pointer-events: none; z-index: 0;
}
.hero-inner { position: relative; z-index: 1; display: contents; }
.hero-left { padding: 64px 52px 64px; display: flex; flex-direction: column; justify-content: center; }
.hero-eyebrow { font-size: 10px; letter-spacing: 0.3em; text-transform: uppercase; color: var(--gold); margin-bottom: 18px; }
.hero-h1 { font-family: 'Libre Baskerville', serif; font-size: clamp(36px, 4.5vw, 62px); font-weight: 400; line-height: 1.1; color: var(--text); margin: 0 0 20px; }
.hero-h1 em { font-style: italic; color: var(--gold); }
.hero-body { font-size: 14px; line-height: 1.8; color: var(--muted);margin-bottom: 32px; font-weight: 300; }
.hero-btns {  gap: 12px; flex-wrap: wrap; justify-content: center; display: flex; }
.btn-gold { width:55%;font-size: 11px; font-weight: 500; letter-spacing: 0.14em; text-transform: uppercase; text-decoration: none; background: var(--gold); color: #0e0e12; padding: 14px 30px; border-radius: 3px; transition: opacity 0.2s; }
.btn-gold:hover { opacity: 0.88; }
.btn-ghost { font-size: 11px; font-weight: 400; letter-spacing: 0.12em; text-transform: uppercase; text-decoration: none; color: var(--muted); border: 1px solid var(--hairline); padding: 14px 30px; border-radius: 3px; transition: border-color 0.2s, color 0.2s; }
.btn-ghost:hover { border-color: var(--gold-dim); color: var(--text); }

/* PORTRAIT */
.hero-right { position: relative; overflow: hidden; }
.portrait-frame { position: absolute; inset: 0; }
.portrait-img { width: 100%; height: 100%; object-fit: cover; object-position: top center; }
.portrait-overlay { position: absolute; inset: 0; background: linear-gradient(90deg, #0e0e12 0%, transparent 40%), linear-gradient(0deg, #0e0e12 0%, transparent 40%); }
.portrait-label { position: absolute; bottom: 28px; left: 28px; }
.pl-name { display: block; font-family: 'Libre Baskerville', serif; font-size: 22px; color: var(--text); margin-bottom: 4px; }
.pl-role { display: block; font-size: 11px; letter-spacing: 0.16em; text-transform: uppercase; color: var(--gold); }

/* CORNER ORNAMENTS */
.corner-ornament { position: absolute; color: var(--gold); opacity: 0.5; }
.tl { top: 16px; left: 16px; }
.br { bottom: 16px; right: 16px; }

/* CONTACT BAR */
.contact-bar { padding: 0 52px; border-bottom: 1px solid var(--hairline); }
.cb-rule { height: 1px; background: linear-gradient(90deg, transparent, var(--gold-dim), transparent); margin: 0; }
.cb-items { display: flex; align-items: center; padding: 20px 0; gap: 0; }
.cb-item { display: flex; flex-direction: column; gap: 2px; padding: 0 32px 0 0; text-decoration: none; }
.cb-label { font-size: 9px; letter-spacing: 0.22em; text-transform: uppercase; color: var(--gold); }
.cb-val { font-size: 13px; color: var(--muted); font-weight: 300; transition: color 0.18s; }
a.cb-item:hover .cb-val { color: var(--text); }
.cb-sep { width: 1px; height: 32px; background: var(--hairline); margin-right: 32px; }

/* REALTOR SECTION */
.realtor-section { padding: 48px 52px; }
.re-card { display: flex; align-items: center; gap: 28px; background: var(--surface); border: 1px solid var(--hairline); border-radius: 8px; padding: 28px 32px; max-width: 680px; position: relative; overflow: hidden; }
.re-card::before { content: ''; position: absolute; top: 0; left: 0; right: 0; height: 1px; background: linear-gradient(90deg, transparent, var(--gold-dim), transparent); }
.re-photo { width: 80px; height: 80px; border-radius: 4px; object-fit: cover; border: 1px solid var(--hairline); flex-shrink: 0; }
.re-card-img { flex-shrink: 0; }

.re-eyebrow { font-size: 9px; letter-spacing: 0.26em; text-transform: uppercase; color: var(--gold); display: block; margin-bottom: 8px; }
.re-name { font-family: 'Libre Baskerville', serif; font-size: 22px; color: var(--text); margin-bottom: 3px; }
.re-brokerage { font-size: 12px; color: var(--muted); margin-bottom: 14px; font-weight: 300; }
.re-contacts { display: flex; flex-wrap: wrap; gap: 8px 20px; }
.re-link { font-size: 12px; text-decoration: none; color: var(--muted); transition: color 0.18s; border-bottom: 1px solid var(--hairline); padding-bottom: 1px; }
.re-link:hover { color: var(--gold); border-color: var(--gold-dim); }
.re-card-cta { flex-shrink: 0; }
.btn-gold-sm { width:55%;font-size: 10px; font-weight: 500; letter-spacing: 0.14em; text-transform: uppercase; text-decoration: none; background: var(--gold); color: #0e0e12; padding: 12px 22px; border-radius: 3px; white-space: nowrap; transition: opacity 0.2s; }
.btn-gold-sm:hover { opacity: 0.88; }

/* FOOTER */
.footer { margin-top: auto; padding: 0 52px 28px; }
.ft-gold-rule { height: 1px; background: linear-gradient(90deg, transparent, var(--gold-dim), transparent); margin-bottom: 20px; }
.ft-inner { display: flex; justify-content: space-between; align-items: center; }
.ft-copy { font-size: 11px; color: var(--muted); letter-spacing: 0.08em; }
.ft-link { font-size: 11px; text-decoration: none; color: var(--gold); letter-spacing: 0.1em; text-transform: uppercase; }
.ft-link:hover { opacity: 0.8; }

@media (max-width: 780px) {
  .hero { grid-template-columns: 1fr; }
  .hero-right { height: 440px; }
  .hero-left { padding: 44px 24px; }
  .nav { padding: 16px 24px; }
  .nav-duo { display: none; }
  .contact-bar { padding: 0 24px; }
  .realtor-section { padding: 32px 24px; }
  .re-card { flex-direction: column; align-items: flex-start; }
  .footer { padding: 0 24px 24px; }
}
</style>
